export const getCommaSeparatedPatientName = (firstName?: string, lastName: string = "") => {
    return firstName ? `${lastName}, ${firstName}` : lastName;
};
